import { Basket } from "../basket/store";
import { t } from "../i18n/t";

const SVG_BASKET = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M5 7h14l-1.5 11.5a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 7Z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>`;

export class BasketFab {
  private el: HTMLElement;
  private bumpTimer: number | null = null;
  private prevCount = 0;

  constructor(parent: HTMLElement, basket: Basket, onClick: () => void) {
    this.el = document.createElement("button");
    this.el.className = "kb-basket-fab";
    this.el.setAttribute("aria-label", t("basket.label"));
    this.el.addEventListener("click", onClick);
    parent.appendChild(this.el);

    basket.subscribe((items) => {
      const count = items.reduce((s, i) => s + i.qty, 0);
      this.render(count);
      if (count > this.prevCount) this.bump();
      this.prevCount = count;
    });
  }

  private render(count: number) {
    const has = count > 0;
    this.el.classList.toggle("has-items", has);
    this.el.innerHTML = `${SVG_BASKET}<span>${t("basket.fab.label")}</span><span class="kb-basket-count">${count}</span>`;
  }

  private bump() {
    if (this.bumpTimer !== null) clearTimeout(this.bumpTimer);
    this.el.classList.remove("bump");
    // Force reflow so the animation can replay
    void this.el.offsetWidth;
    this.el.classList.add("bump");
    this.bumpTimer = window.setTimeout(() => this.el.classList.remove("bump"), 480);
  }
}
